import { DecagramOutlineIcon } from './DecagramOutlineIcon';

/**
 * author: Austin Andrews
 * id 5F4B9A38-F090-4FA3-A138-1F758A9D446E
 * name decagram-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/decagram-outline.svg
 * tags
 * - Shape 
 */
export const StarburstOutlineIcon = DecagramOutlineIcon;
export default StarburstOutlineIcon